import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "../../data/hooks/posthog/usePostHog";

const PostHogPageView = () => {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      posthog.capture("$pageview");
    }
  }, [location, posthog]);

  return null;
};

export default PostHogPageView;
